import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KnowledgeDomainType } from "../../types/KnowledgeDomain";
import { useMutation, useQueryClient } from "react-query";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetKnowledgeDomainsQuery } from "../../hooks/useGetKnowledgeDomainsQuery";
import { updateKnowledgeDomain } from "../../services/school/knowledgedomains/knowledgeDomains";
import { key_KnowledgeDomains } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { setKnowledgeDomainData } from "../../redux/slices/school/knowledgeDomain";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
const columnNamesMap: { [key: string]: string } = {
    description: "Nome",
    code: "Código",
};

export const KnowledgeDomains = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemToBeDeleted, setItemToBeDeleted] = useState<KnowledgeDomainType | null>(null);

    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();
    const { data, status } = useGetKnowledgeDomainsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateKnowledgeDomain, {
        onSuccess: () => {
            queryClient.invalidateQueries(key_KnowledgeDomains);
            toast.success("Dominio de conhecimento removido");
        },
        onError: () => {
            toast.error("Erro ao apagar dominio de conhecimento.");
        }
    });

    const handleCreate = () => {
        navigate(routes.createKnowledgeDomain);
    };

    const handleEdit = (k: KnowledgeDomainType) => {
        dispatch(setKnowledgeDomainData(k));
        navigate(routes.updateKnowledgeDomain);
    };

    const handleDelete = (k: KnowledgeDomainType) => {
        k.status = false;
        mutationUpdate.mutateAsync(k);
    };
    const openDeleteDialog = (s: KnowledgeDomainType) => {
        setItemToBeDeleted(s);
    };
    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted)
        }
    };
    const options = data?.items.map((university) => [
        {
            label: "Editar",
            onClick: () => handleEdit(university),
            icon: <Pencil1Icon />
        },
        {
            label: "Eliminar",
            onClick: () => openDeleteDialog(university),
            icon: <TrashIcon />
        },
    ]) || [];
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
      };
    return (
        <>
        <Lists
            status={status}
            TableComponent={() => (
                <TableComponent
                    columns={Object.keys(columnNamesMap)}
                    items={data?.items}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            )}
            handleClickCreate={handleCreate}
        />
       <ConfirmAlertDialog
                   open={!!itemToBeDeleted}
                   onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                   title="Esta operação é irreversível"
                   item={itemToBeDeleted}
                   onConfirm={confirmDelete}
                   onCancel={() => setItemToBeDeleted(null)}
               />
        </>
    );
}
